import React from "react";
import PropTypes from "prop-types";
import {
  StyledBodyContainer,
  StyledBodyText,
  StyledButton,
  StyledButtonContainer,
  StyledButtonsContainer,
  StyledLi,
  StyledModal,
  StyledNewDivider,
  StyledTitle,
  StyledUl,
} from "./AddressConfirmationModal.styled";

const AddressConfirmationModal = ({
  setCloseModal,
  isOpen,
  isMobile,
  title,
  body,
  agreeButton,
  cancelButton,
}) => {
  React.useEffect(() => {
    if (window.digitalData) {
      window.digitalData.push({
        event: {
          name: "click",
          category: "pop-up",
          label: "delivery-info",
          action: "open",
        },
      });
    }
  }, []);

  return (
    <StyledModal isOpen={isOpen} onClose={setCloseModal}>
      <StyledTitle isMobile={isMobile}>{title}</StyledTitle>
      <StyledNewDivider />
      <StyledBodyContainer
        overflowX="hidden"
        overflowY="auto"
        isMobile={isMobile}
      >
        <StyledUl>
          {body?.map((item) => (
            <StyledLi key={item.id}>
              <StyledBodyText>{item.value.text}</StyledBodyText>
            </StyledLi>
          ))}
        </StyledUl>
      </StyledBodyContainer>
      <StyledNewDivider />
      <StyledButtonsContainer>
        <StyledButtonContainer>
          <StyledButton
            data-cy="address-confirmation-modal-cancel-button"
            text={cancelButton}
            variant="secondary"
            onClick={setCloseModal}
          />
        </StyledButtonContainer>
        <StyledButtonContainer>
          <StyledButton
            data-cy="address-confirmation-modal-agree-button"
            text={agreeButton}
            variant="primary"
            onClick={setCloseModal}
          />
        </StyledButtonContainer>
      </StyledButtonsContainer>
    </StyledModal>
  );
};

AddressConfirmationModal.propTypes = {
  setCloseModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.instanceOf(Array).isRequired,
  agreeButton: PropTypes.string.isRequired,
  cancelButton: PropTypes.string.isRequired,
};

export default AddressConfirmationModal;
